import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { watch } from "vue";
import { useFlyingStars } from "@/utils/useFlyingStars";
import { AptStar } from "@/types/apartmentPlan";
import StarsItem from "@/views/Calculators/ApartmentPlan/components/stage/StarsItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApartmentFlyingStarsLayer',
  props: {
    azimuthFacade: {},
    buildYear: {},
    starsPositions: {},
    getStarIndex: {},
    aptStars: {}
  },
  setup(__props: any) {

const props = __props;

const { fillBuildYearStars, azimuthFacade, flyingStars, buildMountStars } =
  useFlyingStars();

const baseSequence = ["В", "ЮВ", "Ю", "ЮЗ", "З", "СЗ", "С", "СВ"];
const shiftMap = {
  0: { x: 0, y: 10 },
  4: { x: 0, y: 10 },
  5: { x: -10, y: 10 },
  6: { x: -15, y: 0 },
  7: { x: -10, y: -10 },
};

watch(
  () => props.azimuthFacade,
  () => {
    azimuthFacade.value = props.azimuthFacade;
    buildMountStars();
  },
  { immediate: true }
);

watch(
  () => props.buildYear,
  () => {
    if (props.buildYear) {
      fillBuildYearStars(props.buildYear);
    }
  },
  { immediate: true }
);

function getAptStar(index: number) {
  if (props.aptStars === undefined) {
    return null;
  }

  return index + 3 > 8
    ? props.aptStars[((index + 3) % 9) + 1]
    : props.aptStars[index + 3];
}

return (_ctx: any,_cache: any) => {
  const _component_v_group = _resolveComponent("v-group")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.starsPositions, (starPosition, i) => {
    return (_openBlock(), _createBlock(_component_v_group, {
      key: i,
      x: starPosition.x + (shiftMap[i]?.x || 0),
      y: starPosition.y + (shiftMap[i]?.y || 0)
    }, {
      default: _withCtx(() => [
        _createVNode(StarsItem, {
          index: i,
          "base-sequence": baseSequence[i],
          "star-data": _unref(flyingStars)[__props.getStarIndex(i)],
          "apt-star": __props.aptStars ? getAptStar(i) : null
        }, null, 8, ["index", "base-sequence", "star-data", "apt-star"])
      ]),
      _: 2
    }, 1032, ["x", "y"]))
  }), 128))
}
}

})